export const phoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return "";
  }
  if (phoneNumber.startsWith("+852") && phoneNumber.length == 12) {
    return `${phoneNumber.substring(0, 4)} ${phoneNumber.substring(4, 8)} ${phoneNumber.substring(8, 12)}`;
  }
  return phoneNumber;
}
